import React, { useEffect } from 'react';
import { Box, CircularProgress, Divider } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Helper from '../../utility/helper';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import Title from '../../sharedcomponents/title/title';
import RouteConstants from '../../constants/routeConstants';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useState } from '@hookstate/core';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { createTheme } from '@mui/material/styles';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { useEventState } from '../../stores/eventStore';
import DetailsComponent from '../../sharedcomponents/detailsComponent/DetailsComponent';
import { useThemeState } from '../../hookState/ThemeState';
import Logo from '../../assets/images/logo.png';
import DefaultEvent from '../../assets/images/default_event.jpg';
// import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
import SyncRoundedIcon from '@mui/icons-material/SyncRounded';
import AppConstants from '../../constants/appConstants';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
const theme = createTheme();

const useStyles = makeStyles(() => ({
    fontSize: {
        fontSize: 24,
    },
    borderSizeColor: {
        border: '1px solid black',
        color: 'white',
        fontSize: 17,
        fontWeight: 700,
    },
    circuitTitle: {
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'left',
        color: '#3c5c93',
        fontWeight: 600,
    },
}));
const loader = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
};
const MediaCircuit = () => {
    const classes = useStyles();
    const [allData, setAllData] = React.useState(null);
    const loading = useState(true);
    const eventState = useEventState();
    const [showDetails, setShowDetails] = React.useState(false);
    const [showDetailData, setShowDetailData] = React.useState('');
    const [playerDate, setPlayerDate] = React.useState(false);
    const [timeFlag, setTimeFlag] = React.useState(false);
    const [location, setLocation] = React.useState('');
    const themeState = useThemeState();
    const loadingContent = useState(true);
    const eventInfo = Helper.getStorage('eventInfo');
    const agentInfo = Helper.getStorage('agentUser') ? Helper.getStorage('agentUser') : Helper.getSessionStorage('agentUser');
    const userInfo = agentInfo ? agentInfo : Helper.getStorage('userInfo');
    const [descText, setDescText] = React.useState('');

    useEffect(() => {
        const userInfo = Helper.getStorage('userInfo');
        if (eventState.get() && eventState.eventDetail.get() != null) {
            const index = eventState.eventDetail
                .get()
                .moduleDetails?.findIndex((element) => {
                    if (element.moduleName === 'ContentCircuit') {
                        return true;
                    }
                });
            if (!Helper.isAdminUser(userInfo)) {
                if (
                    eventState.eventDetail.get() &&
                    ((index > 0 &&
                        eventState.eventDetail.get().moduleDetails[index]
                            ?.details !== null) ||
                        eventState.eventDetail.get().moduleDetails[index]
                            ?.details !== '')
                ) {
                    setShowDetails(true);
                    setShowDetailData(
                        eventState.eventDetail.get().moduleDetails[index]
                            ?.details
                    );
                } else {
                    setShowDetails(false);
                    setShowDetailData('');
                }
            }
        }
    }, [eventState]);
    const getMediaCircuit = (load) => {
        const agentInfo = Helper.getStorage('agentUser') ? Helper.getStorage('agentUser') : Helper.getSessionStorage('agentUser');
        const userInfo = agentInfo ? agentInfo : Helper.getStorage('userInfo');
        const eventInfo = Helper.getStorage('eventInfo');
        const agentConnection = Helper.getStorage('agentConnections') ? Helper.getStorage('agentConnections') : Helper.getSessionStorage('agentConnections');
        loading.set(load);
        loadingContent.set(!load);
        ApiHelper.get(
            APIURLConstants.GET_MEDIA_CIRCUIT_PARTICIPANT(
                eventInfo.eventID,
                userInfo.userID
            )
        )
            .then((res) => {
                if (res.data) {
                    loading.set(false);
                    loadingContent.set(false);
                    let newRowData = [];
                    res.data.rows.map((activity) => {
                        if (
                            activity.locations &&
                            activity.locations.length > 0
                        ) {
                            setPlayerDate(activity.locations[0].playerDate);
                            activity.locations.map((locas) => {
                                // console.log('activity', locas);
                                if (locas.scheduleDateTime) {
                                    // console.log(
                                    //     'scheduleDateTime',
                                    //     locas.scheduleDateTime
                                    // );
                                    setTimeFlag(true);
                                }
                                newRowData.push(locas);
                            });
                        }
                    });
                    setAllData(newRowData);
                }
            })
            .catch((err) => {
                loading.set(false);

                console.log(err);
            });
    };
    useEffect(() => {
        getMediaCircuit(true);
        getEventLocation();
        getModuleConfig()
    }, []);
    const getModuleConfig = () => {
        const ModuleID = 15;
        const type = "MediaCircuitText";

        ApiHelper.get(APIURLConstants.GET_MODULE_CONFIG(ModuleID, type))
            .then((res) => {
                // console.log(res.data);
                let data = res.data;
                if (data) {
                    // console.log(data);
                    setDescText(data && data[0].value)
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    }
    const refereshPage = () => {
        getMediaCircuit(false);
        getEventLocation();
    };

    const getEventLocation = () => {
        ApiHelper.get(APIURLConstants.GET_EVENT_LOCATION(eventInfo?.eventID)).then(
            (res) => {
                setLocation(res.data ? res.data : '');
            }).catch(err => {
                console.log('error while fetching event info', err)
            });
    }

    return (
        <Box className="contentBox">
            <Title title={Helper.getModuleName(eventInfo ? eventInfo.moduleDetails : [],
                AppConstants.EVENT_MODULES.CONTENT_CIRCUIT)} />
            {showDetails ? <DetailsComponent data={showDetailData} /> : null}

            {loading.get() ? (
                <Box style={loader}>
                    <CircularProgress />
                </Box>
            ) : allData && allData.length > 0 ? (
                <>
                    <Box
                        sx={{ justifyContent: 'center', alignItems: 'center' }}
                        border={5}
                        borderColor={'#ccc'}>
                        <Box sx={{ display: 'flex' }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignContent: 'center',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}>
                                <Box
                                    component="img"
                                    sx={{ height: '140px', pl: 2 }}
                                    alt="logo."
                                    src={
                                        !themeState.eventEnabled.value
                                            ? Logo
                                            : themeState.eventImageUrl.value !=
                                                ''
                                                ? themeState.eventImageUrl.value
                                                : DefaultEvent
                                    }
                                />
                            </Box>
                            <Box
                                sx={{
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    width: '100%',
                                }}>
                                <Box
                                    className={classes.circuitTitle}
                                    sx={{ fontSize: '20px', pl: 2 }}>
                                    Player Media Circuit Schedule
                                </Box>
                                <Divider
                                    sx={{
                                        borderBottomWidth: 'thick',
                                        backgroundColor: '#b3a9a9',
                                        ml: 2,
                                        mr: 2,
                                    }}
                                />

                                <Box
                                    className={classes.circuitTitle}
                                    sx={{ fontSize: '18px', pl: 2, mt: 2 }}>
                                    <ArrowRightIcon sx={{ color: 'red' }} />
                                    <Box component="span" sx={{ width: '17%' }}>
                                        Player
                                    </Box>
                                    <Box
                                        component="span"
                                        sx={{ color: 'black', width: '17%' }}>
                                        {userInfo && userInfo.lastName}
                                        {', '}
                                        {
                                            userInfo && userInfo.firstName
                                        }
                                    </Box>
                                    <Box sx={{ marginLeft: '60%' }}>
                                        <SyncRoundedIcon
                                            sx={{
                                                mt: 1,
                                                fontWeight: 900,
                                                cursor: 'pointer',
                                                background: 'black',
                                                borderRadius: '50px',
                                                color: 'white',
                                            }}
                                            title="Refresh Content Circuit"
                                            onClick={refereshPage}
                                        />
                                    </Box>
                                </Box>
                                {playerDate && (
                                    <Box
                                        className={classes.circuitTitle}
                                        sx={{
                                            fontSize: '18px',
                                            pl: 2,
                                            mt: 2,
                                            pb: 1,
                                        }}>
                                        <ArrowRightIcon sx={{ color: 'red' }} />
                                        <Box
                                            component="span"
                                            sx={{ width: '17%' }}>
                                            Date & Time
                                        </Box>
                                        <Box
                                            component="span"
                                            sx={{ color: 'black' }}>
                                            {!Helper.IfDateIsNULL(playerDate)
                                                ? Helper.FormatDate(
                                                    playerDate
                                                ) +
                                                ' ' +
                                                Helper.FormatTime(playerDate)
                                                : ''}
                                        </Box>
                                    </Box>
                                )}

                                <Box
                                    className={classes.circuitTitle}
                                    sx={{
                                        fontSize: '18px',
                                        pl: 2,
                                        mt: 2,
                                        pb: 1,
                                    }}>
                                    <ArrowRightIcon sx={{ color: 'red' }} />
                                    <Box component="span" sx={{ width: '17%' }}>
                                        Location
                                    </Box>
                                    <Box
                                        component="span"
                                        sx={{ color: 'black' }}> {location ? location :
                                            Helper.getStorage('eventInfo').location}
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                        <Divider
                            sx={{
                                borderBottomWidth: 'thick',
                                backgroundColor: '#b3a9a9',
                                ml: 2,
                                mr: 2,
                                mb: 2,
                            }}
                        />
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                ml: 2,
                                mr: 2,
                                mt: 2, 
                                color:'red',
                                fontWeight: 'bold', 
                            }}
                        >
                            <Box component={'span'} 
                                sx={{ padding:1, }}><ReportProblemIcon sx={{fontSize:'2.5rem'}}/></Box>
                            <Box component={'span'} 
                                sx={{
                                    border:'1px solid red', 
                                    padding:1, 
                                    textAlign:'center',
                                    background:'#ff00001f',
                                    borderRadius:'5px'
                                }}>
                                    {descText}
                                </Box>
                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                ml: 2,
                                mr: 2,
                                mt: 2
                            }}>
                            <TableContainer component={Paper}>
                                <Table
                                    sx={{ minWidth: 650 }}
                                    aria-label="simple table">
                                    <TableHead sx={{ backgroundColor: '#1D4289' }}>
                                        <TableRow>
                                            <TableCell
                                                className={
                                                    classes.borderSizeColor
                                                }
                                                align="center">
                                                Event
                                            </TableCell>
                                            <TableCell
                                                className={
                                                    classes.borderSizeColor
                                                }
                                                align="center">
                                                Room
                                            </TableCell>
                                            {!playerDate && timeFlag && (
                                                <TableCell
                                                    className={
                                                        classes.borderSizeColor
                                                    }
                                                    align="center">
                                                    Activity Date Time
                                                </TableCell>
                                            )}

                                            {/* <TableCell className={classes.borderSizeColor} align="center">Modified By & Date Time</TableCell> */}
                                            <TableCell
                                                className={
                                                    classes.borderSizeColor
                                                }
                                                align="center">
                                                Complete
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {loadingContent.get() ? (
                                            <Box style={loader}>
                                                <CircularProgress />
                                            </Box>
                                        ) : (
                                            allData.map((row, index) => (
                                                <TableRow
                                                    key={`${row.name}_${index}`}
                                                    sx={{
                                                        '&:last-child td, &:last-child th':
                                                            { border: 0 },
                                                    }}>
                                                    <TableCell
                                                        component="th"
                                                        scope="row"
                                                        align="center">
                                                        {row.name}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {row.location}
                                                    </TableCell>
                                                    {!playerDate &&
                                                        timeFlag && (
                                                            <TableCell align="center">
                                                                {row.scheduleDateTime
                                                                    ? !Helper.IfDateIsNULL(
                                                                        row.scheduleDateTime
                                                                    )
                                                                        ? Helper.FormatDate(
                                                                            row.scheduleDateTime
                                                                        ) +
                                                                        ' ' +
                                                                        Helper.FormatTime(
                                                                            row.scheduleDateTime
                                                                        )
                                                                        : ''
                                                                    : ''}
                                                            </TableCell>
                                                        )}

                                                    {/* <TableCell align="center">
                                                        <Box
                                                            display="flex"
                                                            flexDirection={"column"}>
                                                            <Box>{row.modifiedBy}</Box>
                                                            <Box>{!Helper.IfDateIsNULL(
                                                                row.modifiedDate
                                                            )
                                                                ? Helper.FormatDate(
                                                                    row.modifiedDate
                                                                ) +
                                                                ' ' +
                                                                Helper.FormatTime(
                                                                    row.modifiedDate
                                                                )
                                                                : ''}</Box>
                                                        </Box>
                                                    </TableCell> */}
                                                    <TableCell align="center">
                                                        {row.completed ? (
                                                            <CheckCircleRoundedIcon
                                                                className={
                                                                    classes.fontSize
                                                                }
                                                                sx={{
                                                                    color: theme
                                                                        .palette
                                                                        .success
                                                                        .main,
                                                                }}
                                                            />
                                                        ) : null}
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Box>
                </>
            ) : (
                <Box
                    sx={{
                        justifyContent: 'center',
                        alignItems: 'center',
                        display: 'flex',
                    }}
                    borderColor={'#ccc'}>
                    No activities assigned yet
                </Box>
            )}
        </Box>
    );
};

export default {
    routeProps: {
        path: RouteConstants.EVENT_MEDIA_CIRCUIT,
        component: MediaCircuit,
    },
    name: 'MediaCircuit',
};
